var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.classes }, [
    _c("div", [
      _c(
        "svg",
        {
          class: { animation: true, classes: true },
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "-50 -50 100 100",
            preserveAspectRatio: "xMidYMid",
          },
        },
        [
          _c("circle", {
            attrs: {
              cx: "0",
              cy: "0",
              r: "43",
              "stroke-dasharray": "223.83847656827277 74.61282552275759",
              fill: "none",
            },
          }),
        ]
      ),
    ]),
    _vm.label
      ? _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }